document.addEventListener("DOMContentLoaded", function(){

const dateSelect = document.getElementById("delivery_date");
const timeSelect = document.getElementById("delivery_time");

if(!dateSelect || !timeSelect) return;

/* 曜日配列 */
const week = ["日","月","火","水","木","金","土"];

/* 日付生成 */
const start = new Date();
start.setDate(start.getDate()+3);

const end = new Date();
end.setDate(end.getDate()+30);

let current = new Date(start);

while(current <= end){
  const y = current.getFullYear();
  const m = current.getMonth()+1;
  const d = current.getDate();
  const w = week[current.getDay()];

  const value = y+"-"+("0"+m).slice(-2)+"-"+("0"+d).slice(-2);
  const text = y+"年"+m+"月"+d+"日（"+w+"）";

  const option = document.createElement("option");
  option.value = value;
  option.textContent = text;

  dateSelect.appendChild(option);
  current.setDate(current.getDate()+1);
}

});